import { render, staticRenderFns } from "./BunkerSummaryChart.vue?vue&type=template&id=19ec504b"
import script from "./BunkerSummaryChart.vue?vue&type=script&lang=js"
export * from "./BunkerSummaryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports